/* Aseli header behaviour — desktop mega-menu (hover open/close + preview image
   swap), mobile drawer accordion, search toggle. Idempotent: re-inits safely on
   shopify:section:load (theme editor). No external deps. */
(function () {
  'use strict';

  function initHeader(root) {
    if (!root || root.getAttribute('data-aseli-header-bound') === 'true') return;
    root.setAttribute('data-aseli-header-bound', 'true');

    var closeTimer = null;
    var navItems = root.querySelectorAll('[data-mega]');

    function setOpen(key) {
      navItems.forEach(function (it) {
        it.setAttribute('data-open', it.getAttribute('data-mega') === key ? 'true' : 'false');
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.setAttribute('data-active', p.getAttribute('data-panel') === key ? 'true' : 'false');
      });
    }
    function closeAll() {
      navItems.forEach(function (it) { it.setAttribute('data-open', 'false'); });
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.setAttribute('data-active', 'false'); });
      root.querySelectorAll('[data-active]').forEach(function (l) { l.setAttribute('data-active', 'false'); });
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 120);
    }
    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    // desktop: open panel on nav-item hover, keep open while hovering the panel
    navItems.forEach(function (item) {
      var key = item.getAttribute('data-mega');
      item.addEventListener('mouseenter', function () { cancelClose(); setOpen(key); });
      item.addEventListener('mouseleave', scheduleClose);
    });
    root.querySelectorAll('[data-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });

    // preview image swap on link hover; reset to default when leaving the list
    root.querySelectorAll('[data-preview-links]').forEach(function (box) {
      var panel = box.closest('[data-panel]');
      var target = panel && panel.querySelector('[data-preview-target]');
      var defSrc = target && target.getAttribute('data-preview-default-src');
      var defAlt = target && target.getAttribute('data-preview-default-alt');
      box.querySelectorAll('[data-preview-img]').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          if (!target) return;
          target.src = link.getAttribute('data-preview-img');
          target.alt = link.getAttribute('data-preview-alt') || '';
          panel.querySelectorAll('[data-active]').forEach(function (l) { l.setAttribute('data-active', 'false'); });
          link.setAttribute('data-active', 'true');
        });
      });
      box.addEventListener('mouseleave', function () {
        if (!target || !defSrc) return;
        target.src = defSrc;
        target.alt = defAlt || '';
        panel.querySelectorAll('[data-active]').forEach(function (l) { l.setAttribute('data-active', 'false'); });
      });
    });

    // search toggle
    var searchBtn = root.querySelector('[data-search-toggle]');
    var searchRow = root.querySelector('[data-search-row]');
    if (searchBtn && searchRow) {
      searchBtn.addEventListener('click', function () {
        var open = searchRow.getAttribute('data-open') === 'true';
        searchRow.setAttribute('data-open', open ? 'false' : 'true');
        if (!open) {
          var inp = searchRow.querySelector('input');
          if (inp) setTimeout(function () { inp.focus(); }, 0);
        }
      });
    }

    // mobile drawer
    var burger = root.querySelector('[data-drawer-toggle]');
    var drawer = root.querySelector('[data-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = drawer.getAttribute('data-open') === 'true';
        drawer.setAttribute('data-open', open ? 'false' : 'true');
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }
    root.querySelectorAll('[data-drawer-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-drawer-accordion]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aseli-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
